import initSlider from '../sliders/initSlider';
import { tabsSliderOptions, tabsContentSliderOptions } from '../sliders/sliders';
import initChoicesInstance from '../initChoicesInstance';
import showTableDataByValue from '../tables/showTableDataByValue';
import highlightRowsWithDifference from '../tables/highlightRowsWithDifference';
import showAllRows from '../tables/showAllRows';
import toggleRowsWithDifference from '../tables/toggleRowsWithDifference';
import animateTable from '../tables/animateTable';

document.addEventListener('DOMContentLoaded', (e) => {
  const accountsTabsSlider = initSlider('[data-accounts-tabs-slider]', tabsSliderOptions);
  const accountsSlider = initSlider('[data-accounts-slider]', tabsContentSliderOptions);

  /*  */

  const comparisonTable = document.querySelector('[data-comparison-table]');
  const switcher = document.querySelector('[data-table-switcher]');

  const firstSelect = document.querySelector('[data-first-single-choice]');
  const secondSelect = document.querySelector('[data-second-single-choice]');
  const firstSelectInstance = initChoicesInstance(firstSelect);
  const secondSelectInstance = initChoicesInstance(secondSelect);
  const firstSelectValue = firstSelectInstance.getValue(true);
  const secondSelectValue = secondSelectInstance.getValue(true);

  disableOption(firstSelect, secondSelectValue);
  disableOption(secondSelect, firstSelectValue);

  firstSelectInstance.refresh();
  secondSelectInstance.refresh();

  showTableDataByValue(comparisonTable, 1, firstSelectValue);
  showTableDataByValue(comparisonTable, 2, secondSelectValue);
  highlightRowsWithDifference(comparisonTable);

  firstSelect.addEventListener('choice', (e) => {
    const { value } = e.detail;

    disableOption(secondSelect, value);
    secondSelectInstance.refresh();

    showAllRows(comparisonTable);
    showTableDataByValue(comparisonTable, 1, value);
    highlightRowsWithDifference(comparisonTable);
    toggleRowsWithDifference(comparisonTable, switcher);
    animateTable(comparisonTable);
  });

  secondSelect.addEventListener('choice', (e) => {
    const { value } = e.detail;

    disableOption(firstSelect, value);
    firstSelectInstance.refresh();

    showAllRows(comparisonTable);
    showTableDataByValue(comparisonTable, 2, value);
    highlightRowsWithDifference(comparisonTable);
    toggleRowsWithDifference(comparisonTable, switcher);
    animateTable(comparisonTable);
  });

  switcher.addEventListener('click', (e) => {
    toggleRowsWithDifference(comparisonTable, switcher);
    animateTable(comparisonTable);
  });

  /*  */

  const survey = document.querySelector('[data-survey]');
  const syrveyForm = survey.querySelector('[data-form');
  const surveyTabs = [...survey.querySelectorAll('[data-step-tab]')];
  const surveyTabsLength = surveyTabs.length;
  const surveyQuestions = [...survey.querySelectorAll('[data-question]')];
  const surveyNextButton = survey.querySelector('[data-next-button]');
  const surveyAnswerButton = survey.querySelector('[data-answer-button]');
  const nextQuestionText = survey.querySelector('[data-next-question-text');
  const getAnswerText = survey.querySelector('[data-get-answer-text');
  const surveyCurrentStepField = survey.querySelector('[data-current-step]');
  const surveyStepsCountField = survey.querySelector('[data-steps-count]');
  const surveyPercentNumber = survey.querySelector('[data-percent]');
  const surveyResetButton = survey.querySelector('[data-reset]');
  const surveyInputs = [...survey.querySelectorAll('input')];
  const surveyResult = survey.querySelector('[data-result]');
  const suitableAccountsBlock = document.querySelector('[data-suitable-accounts]');
  const suitableAccountsTitles = [...document.querySelectorAll('[data-suitable-account]')];
  const suitableAccountsButtons = [...document.querySelectorAll('[data-open-account]')];

  /*  */

  let currentTab = 1;
  surveyStepsCountField.textContent = surveyTabsLength;

  const validateForm = (tab) => {
    syrveyForm.reportValidity();

    const inputs = surveyTabs[tab - 1].querySelectorAll('input');
    let valid = false;

    for (const input of inputs) {
      if (input.checked) {
        valid = true;
        break;
      }
    }

    return valid;
  };

  const showTab = (num) => {
    if (num <= 0 || num > surveyTabsLength) {
      currentTab = 1;
      showTab(1);
      return;
    }

    currentTab = num;

    showSurveyQuestion(num);
    showSurveyAnswers(num);
    highlightSurveyProgress(num);
    showRelevantNextButton(num);

    surveyCurrentStepField.textContent = num;
    surveyPercentNumber.textContent = countSurveyCompleteness(num - 1, surveyTabsLength);
  };

  const nextTab = () => {
    if (!validateForm(currentTab)) return false;

    showTab(currentTab + 1);
  };

  const showRelevantNextButton = (num) => {
    if (num === surveyTabsLength) {
      surveyNextButton.classList.add('hidden');
      surveyAnswerButton.classList.remove('hidden');

      nextQuestionText.classList.add('hidden');
      getAnswerText.classList.remove('hidden');
    } else {
      surveyAnswerButton.classList.add('hidden');
      surveyNextButton.classList.remove('hidden');

      getAnswerText.classList.add('hidden');
      nextQuestionText.classList.remove('hidden');
    }
  };

  const showSurveyQuestion = (tab) => {
    surveyQuestions.forEach((question) => question.classList.add('hidden'));
    surveyQuestions[tab - 1].classList.remove('hidden');
  };

  const showSurveyAnswers = (tab) => {
    surveyTabs.forEach((tab) => tab.classList.add('hidden'));
    surveyTabs[tab - 1].classList.remove('hidden');
  };

  const highlightSurveyProgress = (tab) => {
    survey.dataset.surveyStep = tab;
  };

  const countSurveyCompleteness = (tab, tabsCount) => (tab / tabsCount) * 100;

  const getSurveyAnswers = () => {
    const answers = {};

    const checkedInputs = survey.querySelectorAll('input:checked');
    checkedInputs.forEach(({ dataset }) => {
      for (const [key, value] of Object.entries(dataset)) {
        if (key === 'gtmFormInteractFieldId') continue;

        if (Object.hasOwn(answers, key)) {
          answers[key] += Number(value);
        } else {
          answers[key] = Number(value);
        }
      }
    });

    return answers;
  };

  const getAnswer = () => {
    if (!validateForm(currentTab)) return false;

    syrveyForm.classList.add('hidden');
    surveyResult.classList.remove('hidden');

    surveyPercentNumber.textContent = countSurveyCompleteness(surveyTabsLength, surveyTabsLength);
    highlightSurveyProgress(currentTab + 1);

    const answers = getSurveyAnswers();
    const suitableAnswers = filterSuitableAnswers(answers);

    const filteredAccounts = suitableAccountsTitles.filter((title) => suitableAnswers.includes(title.dataset.suitableAccount));
    const suitableAccounts = filteredAccounts.map((title) => `<b>${title.textContent}</b>`);

    suitableAccountsBlock.innerHTML = suitableAccounts.join(` ${or} `);

    const suitableButtons = suitableAccountsButtons.filter((button) => suitableAnswers.includes(button.dataset.openAccount));

    suitableAccountsButtons.forEach((button) => button.classList.add('hidden'));
    suitableButtons.forEach((button) => button.classList.remove('hidden'));
  };

  const filterSuitableAnswers = (answers) => {
    const maxValue = Math.max.apply(null, Object.values(answers));
    const filteredAnswers = Object.entries(answers).filter((answer) => answer[1] === maxValue);
    const suitableAnswers = filteredAnswers.map((answer) => answer[0]);

    return suitableAnswers;
  };

  const resetSurvey = () => {
    currentTab = 1;

    syrveyForm.classList.remove('hidden');
    surveyResult.classList.add('hidden');

    surveyInputs.forEach((input) => (input.checked = false));
    showTab(1);
    showRelevantNextButton(1);
  };

  showTab(currentTab);

  surveyNextButton.addEventListener('click', nextTab);
  surveyAnswerButton.addEventListener('click', getAnswer);
  surveyResetButton.addEventListener('click', resetSurvey);
});

const disableOption = (select, value) => {
  const options = [...select.options];
  const optionToDisable = options.filter((option) => option.value === value)[0];

  options.forEach((option) => (option.disabled = false));
  optionToDisable.disabled = true;
};
